import { jsx as _jsx } from "react/jsx-runtime";
import { useAuthentication } from 'xen/hooks';
import RootLoggedIn from 'xen/_modules/home/pages/root-logged-in';
/**
 * Prevents authenticated users from accessing pages meant only for
 * unauthenticated users, e.g. (sign-in, sign-up, etc).
 */
export const RedirectIfAuthenticated = ({ children }) => {
    const { isLoggedIn } = useAuthentication();
    if (isLoggedIn)
        return _jsx(RootLoggedIn, {});
    return children;
};
